import * as Mod1 from "./discourse/components/modal/poll-breakdown";
import * as Mod2 from "./discourse/components/modal/poll-ui-builder";
import * as Mod3 from "./discourse/components/poll-breakdown-chart";
import * as Mod4 from "./discourse/components/poll-breakdown-option";
import * as Mod5 from "./discourse/components/poll-buttons-dropdown";
import * as Mod6 from "./discourse/components/poll-info";
import * as Mod7 from "./discourse/components/poll-option-ranked-choice-dropdown";
import * as Mod8 from "./discourse/components/poll-option-ranked-choice";
import * as Mod9 from "./discourse/components/poll-options";
import * as Mod10 from "./discourse/components/poll-results-pie";
import * as Mod11 from "./discourse/components/poll-results-ranked-choice";
import * as Mod12 from "./discourse/components/poll-results-standard";
import * as Mod13 from "./discourse/components/poll-results-tabs";
import * as Mod14 from "./discourse/components/poll-voted-choices";
import * as Mod15 from "./discourse/components/poll-voters-ranked-choice";
import * as Mod16 from "./discourse/components/poll-voters";
import * as Mod17 from "./discourse/components/poll";
import * as Mod18 from "./discourse/initializers/add-poll-ui-builder";
import * as Mod19 from "./discourse/initializers/extend-for-poll";
import * as Mod20 from "./discourse/initializers/poll-admin-plugin-configuration-nav";
import * as Mod21 from "./discourse/modifiers/decorate-cooked-content";
import * as Mod22 from "./discourse/modifiers/decorate-poll-option";
import * as Mod23 from "./lib/chart-colors";
import * as Mod24 from "./lib/discourse-markdown/poll";
import * as Mod25 from "./lib/even-round";
import * as Mod26 from "./lib/rich-editor-extension";
const compatModules = {
  "discourse/components/modal/poll-breakdown": Mod1,
  "discourse/components/modal/poll-ui-builder": Mod2,
  "discourse/components/poll-breakdown-chart": Mod3,
  "discourse/components/poll-breakdown-option": Mod4,
  "discourse/components/poll-buttons-dropdown": Mod5,
  "discourse/components/poll-info": Mod6,
  "discourse/components/poll-option-ranked-choice-dropdown": Mod7,
  "discourse/components/poll-option-ranked-choice": Mod8,
  "discourse/components/poll-options": Mod9,
  "discourse/components/poll-results-pie": Mod10,
  "discourse/components/poll-results-ranked-choice": Mod11,
  "discourse/components/poll-results-standard": Mod12,
  "discourse/components/poll-results-tabs": Mod13,
  "discourse/components/poll-voted-choices": Mod14,
  "discourse/components/poll-voters-ranked-choice": Mod15,
  "discourse/components/poll-voters": Mod16,
  "discourse/components/poll": Mod17,
  "discourse/initializers/add-poll-ui-builder": Mod18,
  "discourse/initializers/extend-for-poll": Mod19,
  "discourse/initializers/poll-admin-plugin-configuration-nav": Mod20,
  "discourse/modifiers/decorate-cooked-content": Mod21,
  "discourse/modifiers/decorate-poll-option": Mod22,
  "lib/chart-colors": Mod23,
  "lib/discourse-markdown/poll": Mod24,
  "lib/even-round": Mod25,
  "lib/rich-editor-extension": Mod26,
};
export { compatModules };
export default compatModules;
